/**
 * entry point for app
 */

import React, { useState } from "react";
import { BrowserRouter } from "react-router-dom";

import Theme from "./app.context";

import { THEMES } from "./components/common/common.constants";

import Main from "./components/main/Main";

import "./global.scss";

const App = () => {
    const [theme, setTheme] = useState(THEMES.DARK);

    return (
        <Theme.Provider value={{ theme, setTheme }}>
            <BrowserRouter>
                <div className={`theme-${theme}`}>
                    <Main />
                </div>
            </BrowserRouter>
        </Theme.Provider>
    );
};

export default App;
